import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { callSpJbpGlobalPartnerData } from 'partner360/services/callSpJbpGlobalPartnerData'

import { REQUEST_GLOBAL_PARTNER_DATA, YEAR_WHEN_GP_APPEARS } from '../constants'

export const requestGlobalPartnerData = createAsyncThunk(
  REQUEST_GLOBAL_PARTNER_DATA,
  callSpJbpGlobalPartnerData,
  {
    condition: ({ partnerId, fYear }, {}) => {
      if (!partnerId || !fYear) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      return
    },
  }
)
